import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
// 定义主题色
  theme: {
    themes: {
      light: {
        primary: '#3c8cff',
        secondary: '#2b405e',
        anchor: '#8c9eff',
        iconColor: '#0051be',
        fontColor: '#28334a',
        backgroundColor: '#f5f6f9'
      }
    }
  }
})
